import Paper from '@mui/material/Paper';
import { List, ListItem } from '@mui/material';
import { ResultCard } from './ResultCard';
import { QuestionSlide } from '@/types/slide';

interface Props {
    slide: QuestionSlide;
}

export const ResultsDisplay: React.FC<Props> = ({ slide }) => {
    return (
        <Paper sx={(theme) => ({ p: 1, border: 1, borderColor: 'divider', ...theme.applyStyles('light', { backgroundColor: 'grey.200' }) })}>
            <List
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'scroll',
                    p: 0,
                }}
            >
                {slide.questions.map((question, index) => (
                    <ListItem sx={{ p: 1, width: 'auto' }} key={`question-${index}`}>
                        <ResultCard question={question} />
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
};
